import React from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { Link } from '../../atoms/link/Link'
import { InlineWarningBanner } from '../../molecules/inlineWarningBanner/InlineWarningBanner'
import { BodyTextSize } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'

export const CostEstimateErrorBanner = ({
  onPressContactCareNavigator,
}: {
  onPressContactCareNavigator: () => void
}) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()

  return (
    <InlineWarningBanner
      text={formatMessage(
        {
          defaultMessage:
            'We are unable to confirm your cost estimate. <link>Contact your Care Navigator</link> for details.',
          description: 'Error banner text for sessions cost estimate fetch error',
        },
        {
          link: (chunks: string) => (
            <Link
              text={chunks}
              onPress={onPressContactCareNavigator}
              underline
              size={BodyTextSize.DEFAULT}
              testID={tID('SessionList-cost-estimate-error-link')}
              color={colors.textWarning}
              accessibilityLabel='Contact your Care Navigator for cost estimate details'
            />
          ),
        },
      )}
      testId={tID('SessionList-cost-estimate-error-banner')}
    />
  )
}
